
export class LOVProcessedStatusExtension {
}
